/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RelocateScreenerResident200ResponseData
 */
export interface RelocateScreenerResident200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof RelocateScreenerResident200ResponseData
     */
    resident_id: string;
    /**
     * 
     * @type {string}
     * @memberof RelocateScreenerResident200ResponseData
     */
    bed_id: string;
}

/**
 * Check if a given object implements the RelocateScreenerResident200ResponseData interface.
 */
export function instanceOfRelocateScreenerResident200ResponseData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resident_id" in value;
    isInstance = isInstance && "bed_id" in value;

    return isInstance;
}

export function RelocateScreenerResident200ResponseDataFromJSON(json: any): RelocateScreenerResident200ResponseData {
    return RelocateScreenerResident200ResponseDataFromJSONTyped(json, false);
}

export function RelocateScreenerResident200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelocateScreenerResident200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resident_id': json['resident_id'],
        'bed_id': json['bed_id'],
    };
}

export function RelocateScreenerResident200ResponseDataToJSON(value?: RelocateScreenerResident200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resident_id': value.resident_id,
        'bed_id': value.bed_id,
    };
}

